// @ts-nocheck
import Scene from "~/scene";
import { getIcon } from "~/util/providers/poiagg";
/**
 * Marker detailu do mapy
 */
export default class DetailMarker {
	constructor() {
		this._markerDetail = null;
		this._layerMarker = new SMap.Layer.Marker();
	}

	destroy() {
		this._markerDetail.$destructor();
		this._layerMarker.$destructor();
	}

	get layer() {
		return this._layerMarker;
	}

	get coords() {
		return this._markerDetail.getCoords();
	}

	set data(data) {
		const opts = {
			icon: data.typeId ? getIcon(data.typeId) : "",
			size: [20, 20],
		};

		opts.type = opts.icon === "" ? SMap.WMMarker.TYPES.UNIVERSALBIG : Scene.VISUAL.MARKER_WINDY.BIG;

		if (opts.icon !== "") {
			const icon2x = getIcon(data.typeId, { scale: 2 });

			opts.srcset = `${opts.icon} 1x${icon2x ? `, ${icon2x} 2x` : ``}`;
		}

		this._markerDetail = new SMap.WMMarker(SMap.Coords.fromWGS84(data.coords[0], data.coords[1]), null, opts);

		this._markerDetail.getContainer()[SMap.LAYER_MARKER].setAttribute("data-log-ignore", "1");

		this._layerMarker.addMarker(this._markerDetail);
	}
}
